const itemsData = [
  {
    title: "Base element",
    color: "#242424",
    img: "item-images/base.webp",
    miniimg: "item-images/120px/base.webp",
    type: "craft",
  },
  {
    title: "spins",
    color: "#242424",
    miniimg: "item-images/120px/spin-icon.webp",
    type: "stats",
  },
  {
    title: "bestCombo",
    color: "#242424",
    miniimg: "item-images/120px/combo-icon.webp",
    type: "stats",
  },
  {
    title: "Small Lucky Potion",
    color: "#3e7f33",
    img: "potion-images/luck1x1.webp",
    miniimg: "potion-images/120px/luck1x1.webp",
    multiplyer: 10,
    timer: 1,
    type: "potion",
  },
  {
    title: "Small Lucky Potion II",
    color: "#3e7f33",
    img: "potion-images/luck1x2.webp",
    miniimg: "potion-images/120px/luck1x2.webp",
    multiplyer: 25,
    timer: 1,
    type: "potion",
  },
  {
    title: "Small Lucky Potion III",
    color: "#3e7f33",
    img: "potion-images/luck1x3.webp",
    miniimg: "potion-images/120px/luck1x3.webp",
    multiplyer: 50,
    timer: 1,
    type: "potion",
  },
  {
    title: "Medium Lucky Potion",
    color: "#3e7f33",
    img: "potion-images/luck2x1.webp",
    miniimg: "potion-images/120px/luck2x1.webp",
    multiplyer: 10,
    timer: 5,
    type: "potion",
  },
  {
    title: "Medium Lucky Potion II",
    color: "#3e7f33",
    img: "potion-images/luck2x2.webp",
    miniimg: "potion-images/120px/luck2x2.webp",
    multiplyer: 25,
    timer: 5,
    type: "potion",
  },
  {
    title: "Medium Lucky Potion III",
    color: "#3e7f33",
    img: "potion-images/luck2x3.webp",
    miniimg: "potion-images/120px/luck2x3.webp",
    multiplyer: 50,
    timer: 5,
    type: "potion",
  },
  {
    title: "Large Lucky Potion",
    color: "#3e7f33",
    img: "potion-images/luck3x1.webp",
    miniimg: "potion-images/120px/luck3x1.webp",
    multiplyer: 10,
    timer: 10,
    type: "potion",
  },
  {
    title: "Large Lucky Potion II",
    color: "#3e7f33",
    img: "potion-images/luck3x2.webp",
    miniimg: "potion-images/120px/luck3x2.webp",
    multiplyer: 25,
    timer: 10,
    type: "potion",
  },
  {
    title: "Large Lucky Potion III",
    color: "#3e7f33",
    img: "potion-images/luck3x3.webp",
    miniimg: "potion-images/120px/luck3x3.webp",
    multiplyer: 50,
    timer: 10,
    type: "potion",
  },

  {
    title: "Small Speed Potion",
    color: "#1a68c8",
    img: "potion-images/speed1x1.webp",
    miniimg: "potion-images/120px/speed1x1.webp",
    speedBonus: 1500,
    timer: 1,
    type: "potion",
  },
  {
    title: "Small Speed Potion II",
    color: "#1a68c8",
    img: "potion-images/speed1x2.webp",
    miniimg: "potion-images/120px/speed1x2.webp",
    speedBonus: 2500,
    timer: 1,
    type: "potion",
  },
  {
    title: "Small Speed Potion III",
    color: "#1a68c8",
    img: "potion-images/speed1x3.webp",
    miniimg: "potion-images/120px/speed1x3.webp",
    speedBonus: 3000,
    timer: 1,
    type: "potion",
  },
  {
    title: "Medium Speed Potion",
    color: "#1a68c8",
    img: "potion-images/speed2x1.webp",
    miniimg: "potion-images/120px/speed2x1.webp",
    speedBonus: 1500,
    timer: 5,
    type: "potion",
  },
  {
    title: "Medium Speed Potion II",
    color: "#1a68c8",
    img: "potion-images/speed2x2.webp",
    miniimg: "potion-images/120px/speed2x2.webp",
    speedBonus: 2500,
    timer: 5,
    type: "potion",
  },
  {
    title: "Medium Speed Potion III",
    color: "#1a68c8",
    img: "potion-images/speed2x3.webp",
    miniimg: "potion-images/120px/speed2x3.webp",
    speedBonus: 3000,
    timer: 5,
    type: "potion",
  },
  {
    title: "Large Speed Potion",
    color: "#1a68c8",
    img: "potion-images/speed3x1.webp",
    miniimg: "potion-images/120px/speed3x1.webp",
    speedBonus: 1500,
    timer: 10,
    type: "potion",
  },
  {
    title: "Large Speed Potion II",
    color: "#1a68c8",
    img: "potion-images/speed3x2.webp",
    miniimg: "potion-images/120px/speed3x2.webp",
    speedBonus: 2500,
    timer: 10,
    type: "potion",
  },
  {
    title: "Large Speed Potion III",
    color: "#1a68c8",
    img: "potion-images/speed3x3.webp",
    miniimg: "potion-images/120px/speed3x3.webp",
    speedBonus: 3000,
    timer: 10,
    type: "potion",
  },

  {
    title: "Silver ring",
    color: "#243e25",
    img: "ring-images/silver.webp",
    miniimg: "ring-images/120px/silver.webp",
    type: "ring",
    luckBonus: 5,
  },
  {
    title: "Green ring",
    color: "#04a66b",
    img: "ring-images/green.webp",
    miniimg: "ring-images/120px/green.webp",
    type: "ring",
    luckBonus: 10,
  },
  {
    title: "Blue ring",
    color: "#2868a6",
    img: "ring-images/blue.webp",
    miniimg: "ring-images/120px/blue.webp",
    type: "ring",
    luckBonus: 20,
  },
  {
    title: "Purple ring",
    color: "#6e5788",
    img: "ring-images/purple.webp",
    miniimg: "ring-images/120px/purple.webp",
    type: "ring",
    luckBonus: 30,
  },
  {
    title: "Orange ring",
    color: "#e36f3c",
    img: "ring-images/orange.webp",
    miniimg: "ring-images/120px/orange.webp",
    type: "ring",
    luckBonus: 35,
  },
  {
    title: "Rainbow ring",
    color: "#181f2a",
    img: "ring-images/rainbow.webp",
    miniimg: "ring-images/120px/rainbow.webp",
    type: "ring",
    luckBonus: 40,
  },
  {
    title: "Leather glove",
    color: "#e0cfb0",
    img: "glove-images/leather-glove.webp",
    miniimg: "glove-images/120px/leather-glove.webp",
    type: "glove",
    bonusSpinLuck: 10,
  },
  {
    title: "Lucky glove",
    description: "Random Super Luck Potions may appear",
    color: "#1b4b2b",
    img: "glove-images/lucky-glove.webp",
    miniimg: "glove-images/120px/lucky-glove.webp",
    type: "glove",
  },
  {
    title: "Metal glove",
    color: "#284854",
    img: "glove-images/metal-glove.webp",
    miniimg: "glove-images/120px/metal-glove.webp",
    type: "glove",
    bonusSpinLuck: 15,
  },
  {
    title: "Metal magic glove",
    color: "#3dacc9",
    img: "glove-images/metal-magic-glove.webp",
    miniimg: "glove-images/120px/metal-magic-glove.webp",
    type: "glove",
    bonusSpinLuck: 20,
  },

  {
    title: "Magic glove",
    color: "#121b1f",
    img: "glove-images/magic-glove.webp",
    miniimg: "glove-images/120px/magic-glove.webp",
    type: "glove",
    bonusSpinLuck: 25,
  },
  {
    title: "Mecha glove",
    color: "#e0cfb0",
    img: "glove-images/mecha-glove.webp",
    miniimg: "glove-images/120px/mecha-glove.webp",
    type: "glove",
    bonusSpinLuck: 30,
  },
  {
    title: "Rainbow glove",
    color: "#0a1620",
    img: "glove-images/rainbow-glove.webp",
    miniimg: "glove-images/120px/rainbow-glove.webp",
    type: "glove",
    bonusSpinLuck: 35,
  },
  {
    title: "Silver helmet",
    color: "#3d4c54",
    img: "head-images/silver-head.webp",
    miniimg: "head-images/120px/silver-head.webp",
    type: "helmet",
    spinsCount: 9,
  },
  {
    title: "Helmet of Nature",
    color: "#1c312f",
    img: "head-images/green-head.webp",
    miniimg: "head-images/120px/green-head.webp",
    type: "helmet",
    spinsCount: 8,
  },
  {
    title: "Golden Era",
    color: "#aadce5",
    img: "head-images/blue-head.webp",
    miniimg: "head-images/120px/blue-head.webp",
    type: "helmet",
    spinsCount: 7,
  },
  {
    title: "Shadow Helmet",
    color: "#63596d",
    img: "head-images/purple-head.webp",
    miniimg: "head-images/120px/purple-head.webp",
    type: "helmet",
    spinsCount: 6,
  },
  {
    title: "Dragon Helmet",
    color: "#434847",
    img: "head-images/orange-head.webp",
    miniimg: "head-images/120px/orange-head.webp",
    type: "helmet",
    spinsCount: 5,
  },
  {
    title: "Divine Helmet",
    color: "#83b6ae",
    img: "head-images/wings-head.webp",
    miniimg: "head-images/120px/wings-head.webp",
    type: "helmet",
    spinsCount: 4,
  },

  {
    title: "Silver Necklace",
    color: "#89a0a1",
    img: "neck-images/silver-neck.webp",
    miniimg: "neck-images/120px/silver-neck.webp",
    type: "necklace",
    speedBonus: 500,
  },

  {
    title: "Tear of the Earth",
    color: "#077da9",
    img: "neck-images/green-neck.webp",
    miniimg: "neck-images/120px/green-neck.webp",
    type: "necklace",
    speedBonus: 800,
  },

  {
    title: "The Eye of the Elemental",
    color: "#006694",
    img: "neck-images/blue-neck.webp",
    miniimg: "neck-images/120px/blue-neck.webp",
    type: "necklace",
    speedBonus: 1000,
  },

  {
    title: "Fate",
    color: "#5e6d66",
    img: "neck-images/purple-neck.webp",
    miniimg: "neck-images/120px/purple-neck.webp",
    type: "necklace",
    speedBonus: 1500,
  },

  {
    title: "The Dragon's Heart",
    color: "#8e9189",
    img: "neck-images/orange-neck.webp",
    miniimg: "neck-images/120px/orange-neck.webp",
    type: "necklace",
    speedBonus: 1800,
  },

  {
    title: "The Pendant of Defiance",
    color: "#1c2c39",
    img: "neck-images/wings-neck.webp",
    miniimg: "neck-images/120px/wings-neck.webp",
    type: "necklace",
    speedBonus: 2000,
  },

  {
    title: "Dungeon key",
    color: "#CEBB80",
    img: "adventure-images/dungeon-key.webp",
    miniimg: "adventure-images/120px/dungeon-key.webp",
    type: "dungeon-key",
    description: "Opens the gates to the dungeon",
  },

  {
    title: "Upgrade luck",
    color: "#59429b",
    img: "upgrade-images/luck-upgrade.webp",
    miniimg: "upgrade-images/120px/luck-upgrade.webp",
    type: "upgrade-luck",
    description: "Increases luck by 10% when you upgrade your aura",
  },
  {
    title: "Upgrade protect",
    color: "#49a5b8",
    img: "upgrade-images/protect-upgrade.webp",
    miniimg: "upgrade-images/120px/protect-upgrade.webp",
    type: "upgrade-protect",
    description:
      "Protects the aura from resetting the level to 0 in case of an unsuccessful upgrade. The level may drop by 0-2 points",
  },
  {
    title: "Upgrade scroll +1",
    color: "#fccd41",
    img: "upgrade-images/scroll-1.webp",
    miniimg: "upgrade-images/120px/scroll-1.webp",
    type: "upgrade-scroll",
    description: "Allows you to improve your aura by 1 point",
  },
  {
    title: "Upgrade scroll +1-3",
    color: "#df3534",
    img: "upgrade-images/scroll-3.webp",
    miniimg: "upgrade-images/120px/scroll-3.webp",
    type: "upgrade-scroll",
    description: "Allows you to improve your aura by 1-3 points",
  },
];
export default itemsData;
